import React from "react";
import DatePicker from "react-datepicker";
import RsuiteChecker from "../../../RsuiteChecker";
import Select from "react-select";
import CompaniesSelectInput from "./ConpaniesSelectInput";

const InputFieldControl = ({
  fieldName,
  label,
  type,
  isEditing,
  formData,
  handleInputChange,
  data = [],
  multiSelect = false,
  isLoading = false,
  required = false,
  error = null,
  defaultValue = null
}) => {
  let value = formData && formData[fieldName] ? formData[fieldName] : "";

  // Convert stored value to react-select format
  if (type === "select") {
    const rawValue =
      formData && formData[fieldName]
        ? formData[fieldName]
        : multiSelect
        ? []
        : "";

    if (multiSelect) {
      // For multi-select, convert array of IDs to array of option objects
      if (Array.isArray(rawValue)) {
        value = rawValue
          .map((id) => {
            const option = data.find((item) => item.id === id);
            return option ? { label: option.value, value: option.id } : null;
          })
          .filter(Boolean);
      } else {
        value = [];
      }
    } else {
      // For single select, convert ID to option object
      if (rawValue) {
        const option = data.find((item) => item.id === rawValue);
        value = option ? { label: option.value, value: option.id } : null;
      } else {
        value = null;
      }
    }
  } else if (type === "date") {
    value =
      formData && formData[fieldName] ? new Date(formData[fieldName]) : null;
  }

  if (!value && defaultValue) {
    value = defaultValue;
  }

   const handleClear = () => {
    let clearedValue = "";

    if (type === "date") {
      clearedValue = null;
    } else if (type === "select") {
      clearedValue = multiSelect ? [] : "";
    } else {
      clearedValue = "";
    }

    handleInputChange(fieldName, clearedValue);
  };

  const showClear =
    isEditing &&
    !isLoading &&
    ((Array.isArray(value) && value.length > 0) ||
      (!Array.isArray(value) && value));

  return (
    <div className="row d-flex form-customer-activity align-items-center mb16">
      <div className="col-md-4">
        <label htmlFor={fieldName}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      </div>
      <div className="col-md-8">
        {type === "text" ||
        type === "email" ||
        type === "tel" ||
        type === "number" ? (
          <input
            type={type}
            className="form-control"
            name={fieldName}
            id={fieldName}
            value={value}
            onChange={(e) => handleInputChange(fieldName, e.target.value)}
            onKeyDown={(e) => {
              if (
                type === "number" &&
                (e.key === "ArrowUp" ||
                  e.key === "ArrowDown" ||
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "-" ||
                  e.key === "+")
              ) {
                e.preventDefault();
              }
            }}
            onWheel={(e) => {
              if (type === "number") {
                e.target.blur();
              }
            }}
            autoComplete="off"
            disabled={!isEditing || isLoading}
          />
        ) : type === "textarea" ? (
          <textarea
            className="form-control"
            name={fieldName}
            id={fieldName}
            value={value}
            onChange={(e) => handleInputChange(fieldName, e.target.value)}
            disabled={!isEditing || isLoading}
          />
        )
          :
          type === "date" ? (
            <DatePicker
              name={fieldName}
              onKeyDown={(e) => e.preventDefault()}
              dateFormat="dd/MM/yyyy"
              selected={value}
              onChange={(e) => {
                handleInputChange(fieldName, e);
              }}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              // maxDate={Date.now()}
              disabled={!isEditing || isLoading}
            />
          ) : type === "select" && fieldName !== "company_name" ? (
            <Select
              value={value}
              className="single-select"
              classNamePrefix="single-select"
              closeMenuOnSelect={true}
              isClearable={false}
              hideSelectedOptions={false}
              onChange={(event) => {
                // Convert react-select value back to stored format
                let convertedValue;
                if (multiSelect) {
                  // For multi-select, extract array of IDs
                  convertedValue = event
                    ? event.map((option) => option.value)
                    : [];
                } else {
                  // For single select, extract the ID
                  convertedValue = event ? event.value : "";
                }
                handleInputChange(fieldName, convertedValue);
              }}
              options={(data || []).map((item) => {
                return { label: item.value, value: item.id };
              })}
              isMulti={multiSelect}
              isDisabled={!isEditing || isLoading}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          ) : (
            <CompaniesSelectInput
              value={
                formData && formData[fieldName]
                  ? { label: formData[fieldName], value: formData[fieldName] }
                  : null
              }
              onChange={(value) => handleInputChange(fieldName, value)}
              disabled={!isEditing || isLoading}
            />
          )}
        {showClear && type === "select" && (
          <button
            type="button"
            className="btn btn-sm btn-light position-absolute"
            style={{
              right: "46px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              background:"transparent",
              color: "#000",
              position: "absolute"
            }}
            onClick={handleClear}
          >
            ✕
          </button>
        )}
        {error && <div className="text-danger error-message">{error}</div>}
      </div>
    </div>
  );
};

export default InputFieldControl;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/common/InputFieldControl.js